import { AdminTemplate, MerchantReportFilter} from "../../components";

export const MerchantExclusiveReport = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
      <MerchantReportFilter />
    </AdminTemplate>
  );
};
